import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardModule } from 'ngx-clipboard';

import { ItemMetadataModule } from '®shared/item-metadata';
import { FieldedItemModule } from '®shared/list-item/fielded';
import { TrapFocusModule } from '®shared/trap-focus';

import { ShareSheetModalComponent } from './share-sheet-modal.component';
import { shareSheetReducer } from './share-sheet.reducer';
import {
  STATE_FEATURE_SHARE_SHEET,
  getInitialShareSheetState,
} from './share-sheet.state';

@NgModule({
  imports: [
    CommonModule,
    ClipboardModule,
    FieldedItemModule,
    FormsModule,
    ItemMetadataModule,
    ModalModule,
    StoreModule.forFeature(STATE_FEATURE_SHARE_SHEET, shareSheetReducer, {
      initialState: getInitialShareSheetState,
    }),
    TooltipModule,
    TrapFocusModule,
  ],
  declarations: [ShareSheetModalComponent],
  exports: [ShareSheetModalComponent],
})
export class ShareSheetModule {}
